import {BaseParameterFilterInputProps} from "./BaseParameterFilterInputProps";
import {ParameterDataType} from "../../types/Category";

export interface ParameterFilterInputPropsNumber extends BaseParameterFilterInputProps
{
    dataType: ParameterDataType.INTEGER | ParameterDataType.DOUBLE;
    value: string;

    useRange?: boolean;
    minValue?: string;
    maxValue?: string;

    onRangeChange: (
        name: string,
        type: "min" | "max",
        value: string
    ) => void;

    onToggleRange: (
        name: string,
        useRange: boolean
    ) => void;
}


const ParameterFilterInputNumber: React.FC<ParameterFilterInputPropsNumber> = ({
                                                   name,
                                                   dataType,
                                                   value,
                                                   minValue,
                                                   maxValue,
                                                   useRange,
                                                   onChange,
                                                   onRangeChange,
                                                   onToggleRange,
                                               }) => {
    const step = dataType === ParameterDataType.DOUBLE ? "any" : "1";

    return (
        <div>
            <div style={{ marginBottom: 6, display: "flex", flexDirection: "column", gap: "0.35rem" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "0.4rem", fontWeight: "normal", fontSize: "0.95rem", color: "inherit", marginBottom: 0 }}>
                    <input
                        type="radio"
                        checked={!useRange}
                        onChange={() => onToggleRange?.(name, false)}
                    />
                    Exact
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "0.4rem", fontWeight: "normal", fontSize: "0.95rem", color: "inherit", marginBottom: 0 }}>
                    <input
                        type="radio"
                        checked={!!useRange}
                        onChange={() => onToggleRange?.(name, true)}
                    />
                    Range
                </label>
            </div>

            {useRange ? (
                <>
                    <input
                        type="number"
                        step={step}
                        placeholder="Min"
                        value={minValue ?? ""}
                        onChange={(e) =>
                            onRangeChange?.(name, "min", e.target.value)
                        }
                        style={{ width: 90, marginRight: 6 }}
                    />
                    <input
                        type="number"
                        step={step}
                        placeholder="Max"
                        value={maxValue ?? ""}
                        onChange={(e) =>
                            onRangeChange?.(name, "max", e.target.value)
                        }
                        style={{ width: 90 }}
                    />
                </>
            ) : (
                <input
                    type="number"
                    step={step}
                    value={value}
                    placeholder="Exact value"
                    onChange={(e) => onChange(name, e.target.value)}
                    style={{ width: 200 }}
                />
            )}
        </div>
    );
};

export default ParameterFilterInputNumber;
